import { useMatches } from 'react-router';

export const useIsNotFound = (): boolean => useMatches().some((m) => m.id === 'not-found');
